import pluralize from 'pluralize';
import { memo } from 'react';

import { FileStatusButton, FileStatusIconCompleted, FileStatusTitle } from '@air/feature-file-status/ui';
import { Close } from '@air/next-icons';

import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { type AssetTaggingTask, type GetCompletedMetadata } from '~/store/tasks/types';

export type AssetTaggingTaskCompletedPanelItemProps = {
  metadata: GetCompletedMetadata<AssetTaggingTask>;
  onClear: () => void;
};

export const AssetTaggingTaskCompletedPanelItem = memo(
  ({ metadata: { addedTags = [], removedTags = [] }, onClear }: AssetTaggingTaskCompletedPanelItemProps) => {
    const tagCount = addedTags.length + removedTags.length;

    return (
      <PaneItemTW
        avatar={<FileStatusIconCompleted />}
        title={
          <FileStatusTitle data-testid="ASSET_TAGGING_TASK_COMPLETED_PANEL_ITEM_TITLE">Tags updated</FileStatusTitle>
        }
        subtitle={
          tagCount > 0 ? (
            <span className="text-12 text-grey-11">
              {addedTags.length > 0 && `${addedTags.length} ${pluralize('tag', addedTags.length)} added`}
              {addedTags.length > 0 && removedTags.length > 0 && ', '}
              {removedTags.length > 0 && `${removedTags.length} ${pluralize('tag', removedTags.length)} removed`}
            </span>
          ) : undefined
        }
        buttons={
          <FileStatusButton label="Clear" onClick={onClear}>
            <Close className="size-4" />
          </FileStatusButton>
        }
      />
    );
  },
);

AssetTaggingTaskCompletedPanelItem.displayName = 'AssetTaggingTaskCompletedPanelItem';
